export const initialValuesAssignment = {
    taskName: "",
    // taskDuration: "",
    taskType: "",
    startDate: "",
    startTime: "",
    endDate: "",
    endTime: "",
}
